import { Button, Col, Modal, Row } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, withRouter } from 'react-router-dom';
import {
  COMMON_ERROR,
  DRAFT_CHANGE_STATUSES,
  CSV_AMOUNT_INVALID,
  BILL_AMOUNT_VALIDATION_MESSAGE,
  authFeatureConstants,
  PANCARD_REGEX,
  getPrefixforRemark,
} from '../../../../../../shared/constants/commonConstants';
import {
  draftSequence, ERROR, ERROR_MODAL, EXTENDED_STATUS, FORM_SUBMIT_EVENTS,
  SUBMIT_ENBLED_PAYERS,
  UPLOAD_STATUS, DRAFTSTATUS_TO_INDEX_MAP,
  MISSING_VALUE_ERROR,
} from '../../../../../../shared/constants/crmConstants';
import { RootState } from '../../../../../../store';
import { fetchSavedDraft, saveDraftData, updateDraftId, updateSaveDraftStatus } from '../../../../../../store/actions/savedDraftAction';
import { NewAdmissionState } from '../../../../../../store/models/newAdmissionModel';
import { PayerInitialState } from '../../../../../../store/models/payerListModel';
import {
  convertToISOStrings,
  customGTMEvent,
  findKeyValuePair,
  getButtonClassName,
  getButtonDisabled,
  getCurrentUtcTime,
  getIsPageNameEdit,
  getIsPageNameEditDischarge,
  getIsPageNameNewAdmission,
  getIsPageNameReconsider,
  getUploadingFile,
  isBenefSuccess,
  isValidStayLength,
} from '../../../service/crmUtils';
import {
  setAdmissionForm,
  submitAdmission,
  setIsMinimize,
  setClickedOnSkip,
  setIsComeFromSubmit,
  setIsSubmitClicked,
  setCardCollapse,
  setFormAction,
  toggleCSVMismatchModal,
  csvRetry,
  setNameAdharVerified,
  setIsSubmitClickedFromModal,
} from '../../../../../../store/actions/newAdmissionAction';
import { canActivate, centeredNotification } from '../../../../../../utils/utility';
import { InfoCircleTwoTone, InfoCircleOutlined } from '@ant-design/icons';
import { findIndex, isArray, isEmpty } from 'lodash';
import { useNewAdmissionSubmitButton } from '../../../../../../shared/hooks/useSetNewAdmissionButtonText';
import ApplicationDetail from '../../../../../../shared/services/applicationDetail.service';
import useGetPasswordExpireNotification from '../../../../../../shared/hooks/useGetPasswordExpireNotification';
import natural from 'natural';
import { setNotifyModal } from '../../../../../../store/actions/nhcxAction';
import { NHCXState } from '../../../../../../store/models/nhcxModel';
import { fetchOtherClaimDetailMandatoryClassifications } from '../../../../../../store/actions/lookUpAction';
import { HospitalState } from '../../../../../../store/models/hospitalModel';
import HISFileUploadMinimize from '../../../../../../shared/components/fileUpload/HISFileUploadMinimize';
import { ReactComponent as Add_Docs } from '../../../../../../assets/images/svg/HIS_Add_Docs.svg';

const RightHeaderCtaAction = (props: any): ReactElement => {
  const { payer, formControlConfig } = useSelector((state: RootState): PayerInitialState => state.payerList);
  const { form, detailNav, setIsModalVisible, submitNotifier, buddhimedForm } = props;
  const history = useHistory();
  const [clicked, setClicked] = useState(false);
  const isEdit = getIsPageNameEdit(history.location.pathname);
  const isEditDischarge = getIsPageNameEditDischarge(history?.location?.pathname);
  const isEditReconsider = getIsPageNameReconsider(history?.location?.pathname);
  const { DRAFT_INITILIZING, DRAFT_SAVED, NO_CHANGE } = DRAFT_CHANGE_STATUSES;
  const { savedDraftList, draftCurrentStatus, draftErrorMessage } = useSelector((state: RootState): any => state.savedDraft);
  const allDrafts = savedDraftList;
  const location = useLocation();
  const appService = ApplicationDetail.instance;
  const isDocumentEnabledChecklist = ApplicationDetail.instance.getIsDocumentChecklistEnabled();
  const { newAdmission: { adhaarVerified, aadhaarResponse, nameAdhaarVerified, pltMappedValue, searchType,
    selectedOption, panNoVerified, dlVerified, voterIDVerified, panVerified, submitDisabled, claimDetailBackup } }:
    any = useSelector((state: RootState):
      RootState => state);
  const {
    admissionFormVal,
    selectedTab,
    uploadedFiles,
    nonAvailableClassification,
    clickedOnSkip,
    isSubmitClicked,
    selectedBeneficiaryDetail,
    isShowAdmissionForm,
    selectedPackage,
    abhaIdVerifiedData,
    formAction,
    showCsvMismatchModal,
    selectedCenter,
    admissionFormType,
    additionalAdmissionInfo,
    hospitalOtherRoomType,
    panRequired, panCardNumber,
    isBeneficiarySelected,
    isAbhaVerified,
    selectedDiscrepency,
    nonSelectedDiscrepency,
    submitWithoutDocsClicked,
    selectedFiles,
    isDischargeCase,
    automatedProcedureOptions,
    classificationArray,
    showProbability,
    defaultTimeline,
    memberSearchId,
    memberId: memberIdEntered,
    percentageNameMatch,
    govtSchemeUrn,
    selectedHISFiles,
  } = useSelector((state: RootState): NewAdmissionState => state.newAdmission);
  const { claimDetails, isCashlessSubmit } =
    useSelector((state: RootState): any => state.admissionDetails) || {};
  const { isDischargeContestCTA } = claimDetails || {};
  const { isDraftBtnClicked } = useSelector((state: RootState): any => state.selectedInPatientDetail);
  const { isHISClaim }: any = useSelector((state: RootState): HospitalState => state.hospital);
  const dispatch = useDispatch();
  const isPageNameNewAdmission = getIsPageNameNewAdmission(location.pathname);
  let submitDraftObj = {} as any;
  const payerConfigValues = Object.values(formControlConfig);
  const isPanVisible = payerConfigValues?.filter(({ type }: any): boolean => type === 'PanCardFieldPresent').length;
  const isFileUploadRemarkReq = payerConfigValues?.filter(({ requiredFor }: any): boolean =>
    requiredFor?.includes(claimDetails?.nextAllowStatus?.length ? claimDetails?.nextAllowStatus[0] : 'NEWADMISSION'))?.length;
  const isFileUploadRemarkValidation = payerConfigValues?.filter(({ limitValidation }: any): boolean =>
    limitValidation?.includes(claimDetails?.nextAllowStatus?.length ? claimDetails?.nextAllowStatus[0] : 'NEWADMISSION'))?.length;
  const getCustomNotification = useGetPasswordExpireNotification();
  const {
    payerLookUp,
    payerList: { payer: selectedPayer },
  } = useSelector((state: RootState): RootState => state);
  const { uniqueIdentifier, isOnMailPayer = false } = selectedPayer || {};
  const { selectedPatientDetail } = useSelector((state: RootState): any => state.hospital);
  const { notifyModal, coverageResponse, totalAmount, selectedPolicyDetail } = useSelector((state: RootState): NHCXState => state.nhcx);
  const isNHCXEnabledProvider = ApplicationDetail.instance.getIsNHCXEnabledProvider();
  const isPreAuthNewDesignEnabled = ApplicationDetail.instance.getIsPreAuthNewDesignEnabled();
  const [isBenefSearchSuccess, setIsBenefSearchSuccess] = useState(false);
  const fileUploadRemark = defaultTimeline['remarks'][getPrefixforRemark(isDischargeContestCTA)];
  const verifyUpload = (): boolean => {
    // checking the documents checklist
    setTimeout((): any => {
      if (isDocumentEnabledChecklist && payer?.showOtherBuddhimedFlow &&
        (!claimDetails?.nextAllowStatus || !claimDetails?.nextAllowStatus?.length || claimDetails?.nextAllowStatus[0] === 'DISCHARGE')) {
        const icdCode = findKeyValuePair(automatedProcedureOptions, 'id', (form?.getFieldsValue('automatedProcedure')?.automatedProcedure
          || admissionFormVal?.treatmentDetail?.automatedProcedure || claimDetails?.procedureDesc?.[0]?.payerMasterValue))?.icdCode
          || claimDetails?.icd10;
        const { masterLookId: insurerId } =
          findKeyValuePair(payerLookUp[uniqueIdentifier]?.insurerName, 'name', (form?.getFieldsValue('insurerName')?.insurerName ||
            admissionFormVal?.customerDetail?.insurerName || claimDetails?.insurerName)) ||
          findKeyValuePair(payerLookUp[uniqueIdentifier]?.insurerName, 'value', (form?.getFieldsValue('insurerName')?.insurerName ||
            admissionFormVal?.customerDetail?.insurerName || claimDetails?.insurerName)) ||
          {};
        const payload = {
          payerID: payer?.id,

          claimStage: isDischargeCase ? 'DischargeDocumentsSubmitted' : claimDetails?.nextAllowStatus?.length > 0 ?
            claimDetails?.nextAllowStatus[0] : 'NewAdmission',

          treatment: findKeyValuePair(automatedProcedureOptions, 'id', (form?.getFieldsValue('automatedProcedure')?.automatedProcedure ||
            admissionFormVal?.treatmentDetail?.automatedProcedure || claimDetails?.procedureDesc?.[0]?.payerMasterValue))?.name ||
            claimDetails?.procedureDesc?.[0]?.payerMasterValue || '',

          icd: !Array.isArray(icdCode) ? [icdCode] : icdCode || [],

          insurerName: insurerId,
        };
        dispatch(fetchOtherClaimDetailMandatoryClassifications(payload));
      }
    }, 800);

    const isVerifiedAllFiles = uploadedFiles?.length ? uploadedFiles?.every(
      ({ status, extendedStatus }: any): boolean =>
        status === UPLOAD_STATUS.done || (extendedStatus === EXTENDED_STATUS.verified || extendedStatus === EXTENDED_STATUS.uploaded),
    ) : false;
    const allDescripencySorted = nonAvailableClassification
      ?.every(({ isSelectFile, answer }: any): boolean => isSelectFile && answer === 'yes');

    const documentChecklistDescripencySorted = nonAvailableClassification
      ?.some(({ isSelectFile, answer }: any): boolean => isSelectFile && answer === 'yes');

    if (!isVerifiedAllFiles) {
      dispatch(setIsComeFromSubmit(true));
      dispatch(setIsMinimize(false));
      return false;
    }
    if (process.env.REACT_APP_IS_NHCX_ENABLED === 'true' &&
      isNHCXEnabledProvider && isVerifiedAllFiles && !notifyModal && totalAmount > coverageResponse?.balanceSumInsured) {
      dispatch(setNotifyModal(true));
      return false;
    }
    if (process.env.REACT_APP_IS_PAN_CARD_DETAILS_ENABLED === 'true' && isPanVisible) {
      if (panRequired && !panCardNumber) {   // bugix-IPP-4979-commit
        dispatch(setIsMinimize(false));
        centeredNotification('Please enter the PAN number');
        return false;
      } else if (panCardNumber && !(panCardNumber.match(PANCARD_REGEX))) {
        dispatch(setIsMinimize(false));
        centeredNotification('Please enter valid PAN number');
        return false;
      }
    }
    // Checking whether the remarks are entered or not before submitting
    // This applies only for Chola
    if (isFileUploadRemarkReq && !fileUploadRemark) {
      dispatch(setIsMinimize(false));
      return false;
    }

    if (isFileUploadRemarkValidation && fileUploadRemark?.length > 2000) {
      dispatch(setIsMinimize(false));
      return false; // to not allow submission if char length is greater than 2000 [HDFC:Reconsider flow]
    }

    // checking whether the questions are answered are not
    if (isDocumentEnabledChecklist && payer?.showOtherBuddhimedFlow && showProbability > 0) {
      const shouldMinimize = (((!claimDetails?.nextAllowStatus || !claimDetails?.nextAllowStatus?.length
        || claimDetails?.nextAllowStatus?.[0] === 'DISCHARGE') &&
        (!submitWithoutDocsClicked && selectedDiscrepency?.length > 0)));
      if (shouldMinimize) {
        dispatch(setIsMinimize(false));
        return false;
      } else {
        dispatch(setIsMinimize(true));
      }
    }
    const skipDiscrepency = isDocumentEnabledChecklist && payer?.showOtherBuddhimedFlow && claimDetails?.isEnhance;
    const discrepencySorted = showProbability > 0 ? documentChecklistDescripencySorted : allDescripencySorted;
    if (!discrepencySorted && !skipDiscrepency) {
      dispatch(setIsMinimize(false));
      buddhimedForm.validateFields();
      return false;
    }
    return true;
  };
  useEffect((): any => {
    if (formAction === FORM_SUBMIT_EVENTS.SUBMIT) {
      onSubmit();
      dispatch(setFormAction(''));
    }
  }, [formAction]);

  useEffect((): any => {
    if (!isEmpty(claimDetails)) {
      const isSuccessBenefSearch = isBenefSuccess(claimDetails);
      setIsBenefSearchSuccess(isSuccessBenefSearch);
    }
  }, [ claimDetails]);

  useEffect((): void => {
    if (clickedOnSkip) {
      dispatch(submitAdmission(admissionFormVal, (isEdit || isEditDischarge || isEditReconsider), onSuccess, onError));
      dispatch(setIsMinimize(true));
      dispatch(setClickedOnSkip(false));
    }
  }, [clickedOnSkip]);

  const handleBillDetailsSubmissionGAEvent = (): void => {
    if (isDraftBtnClicked) {
      customGTMEvent({
        event: 'DREFT_CLAIM_SUMBITTED',
      });
    }
    if (!uploadedFiles?.length) {
      customGTMEvent({
        event: 'BILL_DETAILS_SUBMITTED',
        ...(form.getFieldsValue() ?? {}),
      });
    }
    const flowName: any = claimDetails?.nextAllowStatus?.[0];
    const eventName =
      flowName === 'ENHANCEMENT' || flowName === 'DISCHARGE'
        ? 'Enhance- Edit Bill Details and Click on Submit'
        : flowName === 'CASHLESSSUMBIT'
          ? 'WA_SETTLEMENT_INITIATION_BILL_DETAILS_ENTERED'
          : flowName === 'SUBMITINFO'
            ? 'WA_QUERY_SBUMISSION_DBILL_DETAILS_ENTERED'
            : 'Submit Early Discharge';
    customGTMEvent({
      event: eventName,
      ...(form.getFieldsValue() ?? {}),
    });
  };

  const onSubmit = (): any => {
    setClicked(true);
    handleBillDetailsSubmissionGAEvent();
    form.validateFields().then((): any => {
      let newFormValue: any = {
        ...admissionFormVal,
        healthId: abhaIdVerifiedData.healthIdNumber,
        abhaAddress: abhaIdVerifiedData.healthId,
        token: abhaIdVerifiedData.token,
      };

      if (detailNav?.length) {
        newFormValue = {
          ...newFormValue,
          ...{
            [detailNav[selectedTab].formKey]: form.getFieldsValue(),
          },
        };
      } else {
        newFormValue = {
          ...newFormValue,
          customerDetail: form?.getFieldsValue(),
          otherFormDetail: form?.getFieldsValue(),
        };
      }
      submitDraftObj = newFormValue;
      dispatch(setAdmissionForm(newFormValue));
      // implemented fuzzy matching for aadhaar verification
      if (process.env.REACT_APP_AADHAAR_VERIFICATION === 'true' && admissionFormType !== 'MULTIPAYER' && !isDraftBtnClicked) {
        const calculateMatchingPercentage = (source: any, target: any): any => {
          const distance = natural.LevenshteinDistance(source?.toLowerCase(), target?.toLowerCase());
          const maxLength = Math.max(source.length, target.length);
          return ((maxLength - distance) / maxLength) * 100;
        };
        const matchPercentage = calculateMatchingPercentage(admissionFormVal?.customerDetail?.fullName, aadhaarResponse);
        if ((adhaarVerified || panNoVerified || dlVerified || voterIDVerified) && matchPercentage > 70) {
          dispatch(setNameAdharVerified(true));
        } else {
          dispatch(setNameAdharVerified(false));
        }
      }
      const isUploadFine = verifyUpload();

      if (isUploadFine) {
        if (!claimDetails?.nextAllowStatus?.[0]) {
          customGTMEvent({
            event: 'WA_NEW_ADMISSION_SUBMIT',
          });
        }

        dispatch(setIsSubmitClicked(true));
        dispatch(
          submitAdmission(newFormValue, (isEdit || isEditDischarge || isEditReconsider), onSuccess, onError),
        );
      }
    })
      .catch((err: any): any => {
        setClicked(false);
        dispatch(setIsSubmitClickedFromModal(false));
      });
  };

  const isSubmitBtnVisible = (): boolean => {
    let isVisible = false;
    if (isShowAdmissionForm
      && (getIsPageNameNewAdmission(history.location.pathname)
        || getIsPageNameEdit(history?.location?.pathname) ||
        getIsPageNameEditDischarge(history.location.pathname) || getIsPageNameReconsider(history?.location?.pathname))) {
      isVisible = true;
    }
    return isVisible;
  };

  const onSuccess = (): any => {
    dispatch(setIsSubmitClicked(false));
    dispatch(setIsSubmitClickedFromModal(false));
    submitNotifier();
    setIsModalVisible(true);
    form.resetFields();
    buddhimedForm.resetFields();
    removeDraftList();
    dispatch(updateDraftId(0));
    dispatch(setCardCollapse({
      isMaternityOpen: false, isOtherTreatmentDetailOpen: false,
      selectedDiagnosisIds: [], isCovidCaseCardOpen: false,
    }));
    dispatch(setFormAction(''));
  };

  const removeDraftList = (): void => {
    const list = allDrafts[draftSequence[isPageNameNewAdmission ? 0 : 2].key] || [];
    const draftIndex = list.findIndex((ele: any): any =>
      ele.newFormValue.customerDetail.memberId === submitDraftObj.customerDetail.memberId);
    if (draftIndex >= 0) {
      list.splice(list.indexOf(draftIndex), 1);
    }
    dispatch(fetchSavedDraft({
      ...allDrafts,
      [allDrafts[draftSequence[isPageNameNewAdmission ? 0 : 2].key]]: list,
    }));
  };

  const onError = (errorMessage: string, duplicateClaimDetails: any): void => {
    setClicked(false);
    dispatch(setIsSubmitClicked(false));
    dispatch(setIsSubmitClickedFromModal(false));
    if (errorMessage === CSV_AMOUNT_INVALID) {
      dispatch(toggleCSVMismatchModal(true));
    } else if (errorMessage === 'PASSWORD_EXPIRED') {
      centeredNotification('Password expired', 'error', (): any => getCustomNotification());
    } else if (isEmpty(duplicateClaimDetails) && errorMessage !== 'NA') {
      centeredNotification(errorMessage || COMMON_ERROR);
    }
  };

  const onSaveToDraft = (showModal: any = true): void => {
    const memberId = form.getFieldValue('memberId');
    const policyNo = form.getFieldValue('policyNumber');
    const employeeId = form?.getFieldValue('employeeId');
    const dateofAdmission = form.getFieldValue('dateOfAdmission');
    const multipayerLengthofStay = form?.getFieldValue('lengthOfStay') || [];
    const dateOfDischarge = form.getFieldValue('dateOfDischarge');
    const stayLength = form?.getFieldValue('stayLength');
    const fullName = form?.getFieldValue('fullName');
    const newDraftFormValue =
      detailNav?.length > 0 &&
        detailNav[selectedTab]?.formKey
        ? {
          [detailNav[selectedTab].formKey]: form.getFieldsValue(),
        } : {
          'customerDetail': form.getFieldsValue(),
          'otherFormDetail': form.getFieldsValue(),
        };
    if (fullName && (memberId || policyNo || employeeId)) {
      const newFormValue = {
        ...admissionFormVal,
        ...newDraftFormValue,
      } as any;

      // remove partially uploaded files before submitting draft
      const partiallyUploadedFile = getUploadingFile(uploadedFiles);
      if (partiallyUploadedFile) {
        const partiallyUploadedFileIndex = findIndex(uploadedFiles, { uid: partiallyUploadedFile?.uid });
        if (partiallyUploadedFileIndex >= 0) {
          uploadedFiles.splice(partiallyUploadedFileIndex, 1);
        }
      }
      if (dateofAdmission || dateOfDischarge || isValidStayLength(stayLength)) {
        const stayLengthISO = convertToISOStrings(stayLength);
        newFormValue.treatmentDetail = {
          ...newFormValue.treatmentDetail,
          dateOfAdmission: stayLengthISO?.[0],
          dateOfDischarge: stayLengthISO?.[1],
          stayLength: stayLengthISO,
        };
      } else {
        if (multipayerLengthofStay || isValidStayLength(stayLength)) {
          const stayLengthISO = convertToISOStrings(stayLength);
          newFormValue.treatmentDetail = {
            ...newFormValue.treatmentDetail,
            dateOfAdmission: stayLengthISO?.[0],
            dateOfDischarge: stayLengthISO?.[1],
            stayLength: stayLengthISO,
          };
          newFormValue.customerDetail = {
            ...newFormValue.customerDetail,
            stayLength: stayLengthISO,
          };
          newFormValue.otherFormDetail = {
            ...newFormValue.otherFormDetail,
            stayLength: stayLengthISO,
          };
        }
      }
      const isNewBornCaseDraft = (isEdit || isEditDischarge || isEditReconsider) &&
        newFormValue?.customerDetail?.isNewBornCase === 'Yes';
      const panCardField = form?.getFieldValue('panNumber')?.toUpperCase();
      let storeObj: any = {
        draftKey: draftSequence[DRAFTSTATUS_TO_INDEX_MAP[claimDetails?.nextAllowStatus?.[0]] ?? 0]?.key,
        newFormValue,
        uploadedFiles,
        payer,
        selectedBeneficiaryDetail,
        selectedPackage,
        claimDetails,
        panCardField,
        searchType,
        pltMappedValue,
        hospitalOtherRoomType,
        nameMatch: nameAdhaarVerified,
        isVerified: adhaarVerified || panNoVerified || dlVerified || voterIDVerified,
        draftBenefSelected: isBeneficiarySelected || isBenefSearchSuccess,
        draftAbhaVerified: isAbhaVerified,
        selectedOption,
        panVerified,
        nonAvailableClassification,
        selectedDiscrepency,
        nonSelectedDiscrepency,
        selectedFiles,
        classificationArray,
        showProbability,
        additionalAdmissionInfo: {
          draftStartTime: additionalAdmissionInfo?.admissionStartTime || '',
          draftEndTime: getCurrentUtcTime(),
        },
        submitDisabled,
        selectedPatientDetail, // to save the details of HIS selected data in case of drafts
        selectedPolicyDetail,
        memberSearchId,
        memberIdEntered,
        percentageNameMatch,
        isNewBornCaseDraft,
        claimDetailBackup,
        govtSchemeUrn,
        isHISClaim,
        selectedHISFiles,
      };

      const courierStatus = storeObj?.claimDetails?.courierStatus;
      if (courierStatus) {
        if (isArray(courierStatus) && courierStatus.length === 0) {
          storeObj.claimDetails = {
            ...storeObj.claimDetails,
            courierStatus: '',
          };
        }
      }
      if (detailNav?.length && detailNav[selectedTab].formKey === 'billDetail') {
        storeObj.newFormValue = {
          ...storeObj.newFormValue,
          billDetail: form.getFieldsValue(),
        };
      }

      if (canActivate(authFeatureConstants.NEW_ADMISSION_BEHALF_OF_HOSPITALS)) {
        storeObj = {
          ...storeObj,
          providerId: selectedCenter?.providerId,
          providerName: selectedCenter?.providerName,
        };
      }

      const successHandler = (): void => {
        dispatch(updateSaveDraftStatus(DRAFT_SAVED));
        centeredNotification('Draft has saved successfully.', 'info');
      };

      const onErrorHandler = (): void => {
        dispatch(updateSaveDraftStatus(showModal ? ERROR_MODAL : ERROR));
      };

      const draftData = isArray(storeObj?.settlement) ? storeObj?.settlement[0] : storeObj;
      dispatch(saveDraftData(draftData, successHandler, onErrorHandler));
    } else {
      if (!fullName) {
        centeredNotification(MISSING_VALUE_ERROR.patientName, 'error');
      } else {
        centeredNotification(MISSING_VALUE_ERROR.memberId, 'error');
      }
    }
  };

  useEffect((): any => {
    if (draftCurrentStatus === DRAFT_INITILIZING) {
      onSaveToDraft(false);
    }
  }, [draftCurrentStatus]);

  const handleCancel = (): any => {
    dispatch(updateSaveDraftStatus(NO_CHANGE));
  };

  const handleOk = (): any => {
    dispatch(updateSaveDraftStatus(NO_CHANGE));
  };

  const onSubmitBill = (): any => {
    dispatch(csvRetry(true));
    dispatch(toggleCSVMismatchModal(false));
    onSubmit();
  };
  const onCancelCsvMismatch = (): any => {
    dispatch(toggleCSVMismatchModal(false));
    dispatch(csvRetry(false));
  };

  let isSubmitBlocked = false;
  if (appService.getIsBetaHospital() && !(SUBMIT_ENBLED_PAYERS?.includes(uniqueIdentifier))) {
    isSubmitBlocked = true;
  }

  const showHisNewadmissionActionBtn = (): any => {
    return (
      !payer?.isClaimSubmissionDisabled &&
      <Row className="header-btn-container" justify="end">

        {(payer?.id !== 0 && isShowAdmissionForm) && <Col md={10} className={`text-right add-docs ${isPreAuthNewDesignEnabled && getIsPageNameNewAdmission(history?.location?.pathname) ? 'his-row-header-cont' : 'non-his-header-row-cont'}`}>
          <>{(uploadedFiles?.length === 0) && <Add_Docs />}<HISFileUploadMinimize /></>
          {/* // <div style={{display: 'flex'}}><Add_Docs /><HISFileUploadMinimize /></div>}</> */}
        </Col>}
        {
          (!isSubmitBlocked && isSubmitBtnVisible() && !(claimDetails?.isQuery || isCashlessSubmit)) &&
          <Col className={`text-right`}>
            <Button
              data-testid="submit-new-admission"
              className={getButtonClassName(isOnMailPayer, submitDisabled)}
              loading={isSubmitClicked}
              onClick={onSubmit}
              disabled={getButtonDisabled(isOnMailPayer, submitDisabled, clicked)}
              htmlType={'submit'}
            >
              {submitBtn}
            </Button>
          </Col>
        }
      </Row>
    );
  };

  const submitBtn = useNewAdmissionSubmitButton();
  return (
    <React.Fragment>

      {showHisNewadmissionActionBtn()}
      <Modal
        visible={draftCurrentStatus === ERROR_MODAL}
        onCancel={handleCancel}
        footer={
          <Row justify="end">
            <Col><Button key="ok" type="primary" onClick={handleOk}>Ok</Button></Col>
          </Row>
        }
      >
        <InfoCircleTwoTone className="fsize_lg" />&nbsp;
        {draftErrorMessage}
      </Modal>
      <Modal
        title={
          <Row>
            <Col>
              <InfoCircleTwoTone className="fsize_lg" />&nbsp;
            </Col>
            <Col>Amount Mismatch</Col>
          </Row>
        }
        visible={showCsvMismatchModal}
        onCancel={onCancelCsvMismatch}
        footer={
          <Row justify="end">
            <Col><Button key="ok" type="primary" onClick={onSubmitBill}>Submit</Button></Col>&nbsp;
            <Col><Button key="Cancel" onClick={onCancelCsvMismatch}>Cancel</Button></Col>&nbsp;
          </Row>
        }
      >
        {BILL_AMOUNT_VALIDATION_MESSAGE}
      </Modal>
      <Modal
        visible={notifyModal}
        className="warningModal"
        closable={false}
        footer={null}>
        <Row className="iconRow">
          <InfoCircleOutlined className="warningModalIcon" />
        </Row>
        <Row className="textRow">
          The claimed amount is greater than the balance sum Insured
        </Row>
        <Row gutter={24} className="warningModalButtons">
          <Col>
            <Button key="close" className="ghost-primary-btn"
              type="ghost" onClick={(): any => {
                dispatch(setNotifyModal(false));
                onSaveToDraft();
              }}>
              Save To Draft
            </Button>
          </Col>
          <Col>
            <Button key="submit" type="primary" onClick={(): any => {
              dispatch(setNotifyModal(false));
              onSubmit();
            }}>
              Submit
            </Button>
          </Col>
        </Row>
      </Modal>
    </React.Fragment>
  );
};

export default withRouter(RightHeaderCtaAction);
